export {
  Accordion,
  type SpectrumAccordionProps as AccordionProps,
  Breadcrumbs,
  type SpectrumBreadcrumbsProps as BreadcrumbsProps,
  Disclosure,
  type SpectrumDisclosureProps as DisclosureProps,
  DisclosureTitle,
  type SpectrumDisclosureTitleProps as DisclosureTitleProps,
  DisclosurePanel,
  type SpectrumDisclosurePanelProps as DisclosurePanelProps,
  Link,
  type SpectrumLinkProps as LinkProps,
  TabList,
  type SpectrumTabListProps as TabListProps,
  Tabs,
  type SpectrumTabsProps as TabsProps,
} from '@adobe/react-spectrum';
export {
  DHCTabPanels as TabPanels,
  type DHCTabPanelsProps as TabPanelsProps,
} from './TabPanels';
